<script>
import {Link, router} from "@inertiajs/vue3";

export default {
  components: {
    Link,
  },

  methods: {
    logout() {
      $.ajax({
        url: route('logout'),
        method: "POST",
      }).always(() => {
        router.visit(route('login'))
      });
    }
  }
}
</script>

<template>
  <header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-dark">
      <div class="navbar-header d-none d-lg-block logo-wrapper">
        <Link class="d-block navbar-brand" :href="route('dashboard')">
            <img src="/assets/images/logo.png" class="light-logo" alt="homepage"/>
        </Link>
      </div>

      <div class="navbar-collapse">
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <a class="nav-link nav-toggler d-block d-md-none waves-effect waves-dark" href="javascript:void(0)">
              <i class="bi bi-list"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link sidebartoggler d-none d-lg-block d-md-block waves-effect waves-dark" href="javascript:void(0)">
              <i class="bi bi-list"></i>
            </a>
          </li>
        </ul>

        <ul class="navbar-nav my-lg-0">
          <li class="nav-item dropdown u-pro">
            <a class="nav-link dropdown-toggle waves-effect waves-dark profile-pic" href="" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ $page.props.auth.user.name }}&nbsp; <i class="bi bi-chevron-down"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end animated flipInY">
              <Link :href="route('profile.edit')" class="dropdown-item">
                <i class="bi bi-person"></i>
                Mijn account
              </Link>

              <div class="dropdown-divider"></div>
              <button @click.prevent="logout" class="dropdown-item">
                <i class="bi bi-box-arrow-right"></i>
                Uitloggen
              </button>
            </div>
          </li>

          <li class="nav-item right-side-toggle">
            <button @click.prevent="logout" class="nav-link waves-effect waves-light" title="Uitloggen" aria-label="Uitloggen">
              <i class="bi bi-box-arrow-right"></i>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>